import { motion, useReducedMotion } from "framer-motion";

/**
 * Scroll-triggered fade + rise, played once. Restrained on purpose (24px, 0.6s)
 * and disabled entirely for visitors who prefer reduced motion.
 */
export default function Reveal({ children, delay = 0, y = 24, className = "", as = "div" }) {
  const reduce = useReducedMotion();
  const Cmp = motion[as] || motion.div;
  return (
    <Cmp
      className={className}
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.12 }}
      transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </Cmp>
  );
}
